import React, {useState, useEffect, useRef} from 'react';
import {makeRequest} from "../../utils/httpRequest";
import Config from "../../core/config";
import {useRecoilState} from "recoil";
import {loadingAtom} from "../../atoms";import WhatsAppButton from "../../core/WhatsAppButton";
import {useNavigate} from "react-router-dom";
import Loading from "../../core/Loading";
import {UserPermission} from "../../utils/utils";
import {usePermission} from "../../core/PermissionContext";

const apiUrl = Config.apiUrl;

const CustomerList = () => {
    const { hasUserPermission, loadingPermissions } = usePermission();
    let [customers, setCustomers] = useState([]);
    const [queryString, setQueryString] = useState('');
    const inputQueryString = useRef(null);
    const [loading, setLoading] = useRecoilState(loadingAtom);
    const navigate = useNavigate();

    async function makeQuery(query) {
        try {
            setLoading(true);
            const url = apiUrl + '/api/customers/query=' + (query && query !== '' ? (query) : '');
            const response = await makeRequest(url, 'GET');
            setCustomers(response);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (inputQueryString.current) {
            inputQueryString.current.focus();
        }
        makeQuery('');
    }, []);

    async function deleteCustomer(id) {
        try {
            setLoading(true);
            const url = apiUrl + '/api/customers/' + id;
            await makeRequest(url, 'DELETE');
            await makeQuery(queryString);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    }

    const handleInputChange = (e) => {
        const string = e.target.value;
        if (string.length >= 3 || string.length === 0) {
            makeQuery(string);
        }
        setQueryString(string);
    };

    const [sortConfig, setSortConfig] = useState({ key: 'name', direction: 'ascending' });

    const sortedCustomers = [...customers].sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
            return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
            return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
    });

    const handleSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    const getSortIcon = (key) => {
        if (sortConfig.key === key) {
            return sortConfig.direction === 'ascending' ? '▲' : '▼';
        }
        return '';
    };

    if (loadingPermissions) {
        return <Loading></Loading>;
    }
    if (hasUserPermission(UserPermission.LIST_CUSTOMER) === false) {
        navigate('/unauthorizedaccess');
        return null;
    }

    return (
        <>
            <div style={{display: "flex", alignItems: "center", gap: '10px'}}>
                <div className="header-label">Consulta de Clientes</div>
                {hasUserPermission(UserPermission.CREATE_CUSTOMER) &&
                    <button className={"new-button"} onClick={() => navigate('/app/customer')}>Novo</button>
                }
            </div>

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                <input ref={inputQueryString} type="text" value={queryString} onChange={handleInputChange} />
            </div>

            <table style={{ width: '580px', height: '501px' }}>
                <thead>
                <tr>
                    <th style={{ cursor:"pointer", minWidth:"100px" }} onClick={() => handleSort('code')}>
                        Código {getSortIcon('code')}
                    </th>
                    <th style={{ cursor:"pointer" }} onClick={() => handleSort('name')}>
                        Nome {getSortIcon('name')}
                    </th>
                    <th />
                    <th />
                    <th />
                </tr>
                </thead>
                <tbody style={{ overflowY: 'auto' }}>
                {sortedCustomers.map((customer, index) => (
                    <tr key={index}>
                        <td>
                            <div>{customer.code}</div>
                        </td>
                        <td>
                            <div>{customer.name}</div>
                        </td>
                        <td>
                            {customer.phone && <WhatsAppButton phoneNumber={customer.phone} />}
                        </td>
                        <td>
                            {hasUserPermission(UserPermission.EDIT_CUSTOMER) &&
                                <button data-test="edit-button" className="edit-button" onClick={async () => {
                                    await navigate('/app/customer?id=' + customer.id);
                                }}>Editar</button>
                            }
                        </td>
                        <td>
                            {hasUserPermission(UserPermission.REMOVE_CUSTOMER) &&
                                <button data-test="remove-button" className="remove-button" onClick={async () => {
                                    // eslint-disable-next-line no-restricted-globals
                                    if (window.confirm('Deseja realmente excluir?')) {
                                        await deleteCustomer(customer.id);
                                    }
                                }}>Excluir</button>
                            }
                        </td>
                    </tr>
                ))}
                </tbody>
                {customers.length === 0 && (<tfoot><tr><td colSpan="5">{loading ? 'Carregando...' : 'Nenhum item encontrado.'}</td></tr></tfoot>)}
            </table>
        </>
    );
};

export default CustomerList;
